// European Collection — European luxury motorhome imagery.
//
// Iteration 109: Owner-approved European stock imagery landed via the
// canonical manifest (see /lib/photos/manifest.js).  This module now only
// exposes true European motorhome photography (Morelo Grand Empire on a
// Mercedes-Benz Actros chassis, Morelo interior, and a Niesmann+Bischoff
// Arto).  The previous Newell / Prevost stand-ins have been retired.
import { _ASSET_BASE } from "./_base";

const EU_HERO    = `${_ASSET_BASE}/vwns632h_IMG_5603.jpeg`; // Morelo Grand Empire · fjord
const EU_ACCENT  = `${_ASSET_BASE}/s3mww19o_IMG_5609.jpeg`; // Niesmann+Bischoff Arto · urban
const EU_INTERIOR = `${_ASSET_BASE}/g6a4ttsq_IMG_5604.jpeg`; // Morelo · walnut/cream interior

export const EUROPEAN_MOTORHOME_PHOTOS = [
  EU_HERO,
  EU_ACCENT,
  EU_INTERIOR,
];

const european = {
  hero: EU_HERO,
  accent: EU_ACCENT,
  gallery: [EU_INTERIOR],
  card: EU_HERO,
  social: EU_HERO,
};
export default european;
